import { FleekError } from './FleekError';

type MissingTwoFactorProtectionCredentialsErrorOptions = Record<string, never>;

export class MissingTwoFactorProtectionCredentialsError extends FleekError<MissingTwoFactorProtectionCredentialsErrorOptions> {
  public name = 'MissingTwoFactorProtectionCredentialsError';

  toString = () => 'Missing two factor protection credentials. Either a token or a recovery key should be provided.';
}
